import React from 'react';
import ReactDOM from 'react-dom/client';
import './assests/css/bootstrap.min.css';
import './assests/css/style.css';
// react library for routing
import { BrowserRouter, Route, Routes , Navigate  } from "react-router-dom";
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';

import AuthLayout from "./layouts/Auth.js";
import Admin from './layouts/Admin.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    
    <BrowserRouter>
      <Routes >
        {/* <Route path="/rtl" element={<App  />} /> */}
        <Route path="/admin/*" element={<Admin  />} />
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="*" element={<Navigate to ="/auth/login" />} />  
        {/* <Navigate  from="*" to="/" /> */}
      </Routes >
    </BrowserRouter>

  // </React.StrictMode>
);

// Deployment Check

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
